import { render, staticRenderFns } from "./batch-table.vue?vue&type=template&id=610b86d9&scoped=true"
import script from "./batch-table.vue?vue&type=script&lang=js"
export * from "./batch-table.vue?vue&type=script&lang=js"
import style0 from "./batch-table.vue?vue&type=style&index=0&id=610b86d9&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "610b86d9",
  null
  
)

export default component.exports